import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, SecurityContext, input } from '@angular/core';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { IconBigMediumPfeilRechts } from '@big-direkt/utils/icons';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardBaseComponent } from '../../card-base.component';
import { CardLinkComponent } from '../card-link/card-link.component';
import { CardComponent } from '../card/card.component';
import { UiCardHeadlineTextLinkModel } from './card-headline-text-link.model';

@Component({
    selector: 'big-ui-card-headline-text-link',
    templateUrl: './card-headline-text-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent, NgClass, Nl2brPipe, SanitizePipe, UiSvgIconModule, TranslocoDirective, CardLinkComponent],
})
export class CardHeadlineTextLinkComponent extends CardBaseComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    public readonly data = input.required<UiCardHeadlineTextLinkModel>();
    public readonly hideLink = input(false);

    public readonly customCardClass = input<string>('bg-white dark:bg-primary');
}
